import { useLinkToolbarButton, useLinkToolbarButtonState } from '@alpod-ai-writer/plate-plugins/link/react';
import { withRef } from '@udecode/cn';
import { Link } from 'lucide-react';

import { ToolbarButton } from '../common/toolbar.component';

export const LinkToolbarButton = withRef<typeof ToolbarButton>((rest, ref) => {
    const state = useLinkToolbarButtonState();
    const { props } = useLinkToolbarButton(state);
    return (
        <ToolbarButton
            ref={ref}
            data-plate-focus
            tooltip="Vložit odkaz"
            {...props}
            {...rest}
        >
            <Link />
        </ToolbarButton>
    );
});
